exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-tips-col{background-color:#024659;padding-top:.7rem;padding-bottom:.3rem}.search-tips-col p{margin-bottom:.4rem;text-align:center;color:#fff}", ""]);

// exports
